import styled from 'styled-components';

/**
 * A wrapper for `Dialog` footer content
 * (content will automatically be wrapped when using the `footer` prop).
 *
 * @related [`Dialog`]
 * @since 7.0.0
 */
var DialogFooter = /*#__PURE__*/styled.footer.withConfig({
  displayName: "DialogFooter",
  componentId: "c11n-8-107-0__sc-3beuip-0"
})([""]);
DialogFooter.displayName = 'DialogFooter';

/** @component */
export { DialogFooter };